// extracted by mini-css-extract-plugin
export default {"container":"ProfileCardsSection_container__5Io0x","navigation_trick_element":"ProfileCardsSection_navigation_trick_element__d3t2N"};